import React from 'react';
import { Link } from 'react-router-dom';
import { categoryCircles } from '../../data/navigation';
export function CategoryCircles() {
  return <section className="mx-auto max-w-7xl px-5 pt-14 lg:px-8 lg:pt-20" aria-labelledby="shop-categorie" data-id="element-52" data-mp="q18m5lwglnr0">
      <h2 id="shop-categorie" className="text-center font-display text-3xl uppercase tracking-display text-ink sm:text-4xl" data-id="element-53" data-mp="v0201ffnrgrp">
        Shop per categorie
      </h2>
      <ul className="no-scrollbar -mx-5 mt-8 flex gap-4 overflow-x-auto px-5 lg:mx-0 lg:grid lg:grid-cols-8 lg:gap-5 lg:overflow-visible lg:px-0" data-id="element-54" data-mp="2ejxmhcy2x1f">
        {categoryCircles.map(c => <li key={c.to} className="shrink-0" data-id="element-55" data-mp="bdx8negpvto9">
            <Link to={c.to} className="group flex w-28 flex-col items-center text-center lg:w-auto" data-id="element-56" data-mp="bc2nbz1j9zjn">
              <span className="block aspect-square w-full overflow-hidden rounded-full bg-surface ring-1 ring-line transition-[box-shadow] duration-150 group-hover:ring-2 group-hover:ring-ink" data-id="element-57" data-mp="g707a10cptbb">
                <img src={c.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.06]" data-id="element-58" data-mp="3jrw5eibijj2t" />
              </span>
              <span className={`mt-3 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.1em] ${c.to === '/living' ? 'text-pink' : 'text-ink'}`} data-id="element-59" data-mp="14pj1217bsxc3">
                {c.label}
              </span>
            </Link>
          </li>)}
      </ul>
    </section>;
}